const riot = require('riot');

riot.tag2('atom-anchorify', '<div class="white-space-pre-wrap word-break-all transition {&quot;line-clamp-1&quot; : opts.timeline}" riot-style="height: {hasMore ? border_height : description_height}px;" ref="description"><span each="{item in getItems()}"><span if="{item.type === &quot;text&quot;}">{item.text}</span><a class="text-link" href="{item.url}" if="{item.type === &quot;url&quot;}" onclick="event.stopPropagation()" target="_blank">{item.url}</a></span></div> <div class="f fr" if="{hasMore}"> <div class="cursor-pointer fs12 text-deepgray pl16 pt8" onclick="{readMore}">続きを読む</div> </div>', 'atom-anchorify,[data-is="atom-anchorify"]{display:block}', '', function(opts) {
    this.on('mount', () => {

      if (this.opts.timeline) {
        setTimeout(() => {

          this.description_height = this.refs.description.scrollHeight;

          if (app.media === 'mobile') {

            this.border_height = 13 * 1.4 * 1;
          }
          else {

            this.border_height = 13 * 1.2 * 1;
          }

          if (this.description_height > this.border_height) {
            this.hasMore = true;
          }
          this.update();
        });
      }
    });

    this.getItems = () => {
      var items = [];

      if (opts.text) {
        var urlTest = /https?:\/\/[\w\/:%#\$&\?\(\)~\.=\+\-\_\@]+/g;

        var matched;

        var lastIndex = 0;

        while (matched = urlTest.exec(opts.text)) {

          var text = opts.text.slice(lastIndex, matched.index)
          if (text) {
            items.push({
              type: 'text',
              text,
            });
          }

          var url = matched[0];
          items.push({
            type: 'url',
            url,
          });
          lastIndex = matched.index + url.length;
        }

        var text = opts.text.substr(lastIndex);
        if (text.trim()) {
          items.push({
            type: 'text',
            text,
          });
        }
      }

      return items;
    };

    this.readMore = () => {
      this.refs.description.classList.remove('line-clamp-1');
      this.hasMore = false;
      this.update();
    };
});